
export const web3Context = {
  WEB3_LOCKED: "LOCKED",
  WEB3_LOAD_ERR: "LOAD_ERROR",
  WEB3_NET_ERR: "NETWORK_ERROR",
  WEB3_LOADING: "LOADING",
  WEB3_LOADED: "LOADED",
  WEB3_CONTRACT_ERR: "CONTRACT_ERROR"
}

export const netContext = {
  MAIN: 1,
  MORDEN: 2,
  ROPESTEN: 3,
  RINKEBY: 4,
  KOVAN: 42,
  LOCAL: -1
}

export const txStatus = {
  NEW: "TX_NEW",
  PENDING: "TX_PENDING",
  MINED: "TX_MINED",
  FAILED: "TX_FAILED",
  SUCCESS: "TX_SUCCESS"
}

export const contractAddress = {
  oraclesController: "0x1e3F3338db55Fd3E3fC7bbdff473C291cb7fDCc1"
}

export const ethMultiplier = 1000000000000000000;
export const mvuMultiplier = 100000;

export const decimalsToShow = 4;

export const zeroAddress = "0x0000000000000000000000000000000000000000";


// WEBPACK FOOTER //
// ./src/constants.js